import { Portal } from "@radix-ui/react-alert-dialog";

type AlertPortalProps = {
  children: React.ReactNode;
};

const AlertPortal = ({ children }: AlertPortalProps) => (
  <Portal>{children}</Portal>
);

export { AlertPortal };
